module.exports = __webpack_public_path__ + "static/media/img4.de17fcb6.jpg";